import { ApolloLink, DocumentNode, Observable } from '@apollo/client';
import getUpdateAdAccountPinnedResult from 'auth/lib/mocks/getupdateAdAccountPinnedResult';
import getUpdateClientDashboardSettingsResult from 'auth/lib/mocks/getUpdateClientDashboardSettingsResult';

type Mock = [
	// Query name
	string,
	// Query result function
	(query: DocumentNode, variables: Record<string, any>) => any,
];

export const mocks: Mock[] = [
	[
		'spotifyUpdateAdAccountPinned',
		getUpdateAdAccountPinnedResult,
	],
	[
		'spotifyUpdateClientDashboardSettings',
		getUpdateClientDashboardSettingsResult,
	],
];

const createMockLink = () => new ApolloLink((operation) => {
	const { operationName, variables, query } = operation;

	const mock = mocks.find(([name]) => name === operationName);

	if (mock) {
		console.log('operationName: ', operationName);
		console.log('mock: ', mock);
		console.log('variables: ', variables);
		console.log('data: ', mock[1](query, variables));
		console.log('string query: ', query.loc?.source.body);

		return Observable.of({
			data: mock[1](query, variables),
		});
	}

	return null;
});

export default createMockLink;
